export default {
  methods: {
    truncatedText(valor){
        const words = valor.split(' ');
        if (words.length > 3) {
            return words.slice(0, 3).join(' ') + '...';
        }
        return words
    }
  }
}